module.exports = __webpack_public_path__ + "static/npf_logo-3fc227a0442b0222e72f45bd84bd405d.png";